(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener('click', this.openSelector.bind(this));
			this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			const form = this.querySelector('form');
			this.elements.input.value = event.currentTarget.dataset.value;
			if (form) form.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
		}

		closeSelector(event) {
			const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.getElementById('shopify-section-header');
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);
			this.createObserver();
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop> this.headerBounds.bottom) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false;
					}, 66);

					requestAnimationFrame(this.hide.bind(this));
				}
			} else if (scrollTop <= this.headerBounds.top) { 
				requestAnimationFrame(this.reset.bind(this)); 
			}
			this.currentScrollTop=scrollTop; 
		} 
		
		hide() {
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure(); 
			this.closeSearchModal();
		} 
		
		reveal() {
			this.header.classList.add('shopify-section-header-sticky', 'animate' );
			this.header.classList.remove('shopify-section-header-hidden'); 
		}
		
		reset() {
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky' , 'animate' ); 
		}
		
		closeMenuDisclosure() { 
			this.disclosures=this.disclosures || this.header.querySelectorAll('details-disclosure');
			this.disclosures.forEach(disclosure=> disclosure.close());
		}
		
		closeSearchModal() {
			this.searchModal = this.searchModal || this.header.querySelector('details-modal');
			this.searchModal.close(false);
		}
	}

	customElements.define('sticky-header', StickyHeader);

	const _header = document.querySelector('.header-sticky');

	function scrollDetect() {
		var lastScroll = 0;
	  
		window.onscroll = function() {
			let currentScroll = document.documentElement.scrollTop || document.body.scrollTop; // Get Current Scroll Value
	  
			if (currentScroll > 0 && lastScroll <= currentScroll) {
				lastScroll = currentScroll;
				_header.classList.add('header-sticky__scrolling');
			  	/*document.getElementById("scrollLoc").innerHTML = "Scrolling DOWN";*/
				if(window.location.pathname.includes("/collections/")) {
					document.querySelector('.collection-page__template--container__sidebar').style.top = '36px';
				}
			} else {
			  	lastScroll = currentScroll;
				_header.classList.remove('header-sticky__scrolling');
			  	/*document.getElementById("scrollLoc").innerHTML = "Scrolling UP";*/
				if(window.location.pathname.includes("/collections/")) {
					document.querySelector('.collection-page__template--container__sidebar').style.top = '108px';
				}
			}
		};
	}

	if (window.screen.width <= 768) {
		scrollDetect();
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-press-bar"] && !window.DesignMode) return;
  try {
    
    $('.home__press-bar--list').slick({
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg width='14' height='26' viewBox='0 0 14 26' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.999761 13C0.998963 13.4089 1.14137 13.8052 1.40226 14.12L10.1523 24.62C10.4493 24.9774 10.8761 25.2021 11.3389 25.2448C11.8016 25.2875 12.2624 25.1445 12.6198 24.8475C12.9771 24.5505 13.2019 24.1236 13.2445 23.6609C13.2872 23.1981 13.1443 22.7374 12.8473 22.38L5.00726 13L12.5673 3.62C12.7126 3.441 12.8212 3.23503 12.8867 3.01394C12.9522 2.79285 12.9734 2.56099 12.949 2.33169C12.9246 2.10239 12.8551 1.88017 12.7445 1.6778C12.634 1.47544 12.4845 1.29692 12.3048 1.15251C12.1248 0.992241 11.9137 0.870863 11.6847 0.795975C11.4557 0.721088 11.2136 0.694307 10.9738 0.717308C10.7339 0.740309 10.5014 0.812593 10.2908 0.92964C10.0801 1.04669 9.89597 1.20597 9.74976 1.39751L1.29726 11.8975C1.07761 12.2214 0.972863 12.6096 0.999761 13Z' fill='#D9D9D9'/></svg></button>",
        nextArrow:"<button class='slick-next slick-arrow' aria-label='Previous' type='button'><svg width='14' height='26' viewBox='0 0 14 26' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.999761 13C0.998963 13.4089 1.14137 13.8052 1.40226 14.12L10.1523 24.62C10.4493 24.9774 10.8761 25.2021 11.3389 25.2448C11.8016 25.2875 12.2624 25.1445 12.6198 24.8475C12.9771 24.5505 13.2019 24.1236 13.2445 23.6609C13.2872 23.1981 13.1443 22.7374 12.8473 22.38L5.00726 13L12.5673 3.62C12.7126 3.441 12.8212 3.23503 12.8867 3.01394C12.9522 2.79285 12.9734 2.56099 12.949 2.33169C12.9246 2.10239 12.8551 1.88017 12.7445 1.6778C12.634 1.47544 12.4845 1.29692 12.3048 1.15251C12.1248 0.992241 11.9137 0.870863 11.6847 0.795975C11.4557 0.721088 11.2136 0.694307 10.9738 0.717308C10.7339 0.740309 10.5014 0.812593 10.2908 0.92964C10.0801 1.04669 9.89597 1.20597 9.74976 1.39751L1.29726 11.8975C1.07761 12.2214 0.972863 12.6096 0.999761 13Z' fill='#D9D9D9'/></svg></button>",
        responsive: [
            {
                breakpoint: 9999,  
                settings: "unslick"
            },
            {
                breakpoint: 973,
                settings: {
                    arrows: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    infinite: true,
                    adaptiveHeight: true
                }
            },
            {
                breakpoint: 821,
                settings: {
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    infinite: true,
                    adaptiveHeight: true
                }
            }
        ]
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-value-props"] && !window.DesignMode) return;
  try {
    
    $('.home__press-bar--list').slick({
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg width='14' height='26' viewBox='0 0 14 26' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.999761 13C0.998963 13.4089 1.14137 13.8052 1.40226 14.12L10.1523 24.62C10.4493 24.9774 10.8761 25.2021 11.3389 25.2448C11.8016 25.2875 12.2624 25.1445 12.6198 24.8475C12.9771 24.5505 13.2019 24.1236 13.2445 23.6609C13.2872 23.1981 13.1443 22.7374 12.8473 22.38L5.00726 13L12.5673 3.62C12.7126 3.441 12.8212 3.23503 12.8867 3.01394C12.9522 2.79285 12.9734 2.56099 12.949 2.33169C12.9246 2.10239 12.8551 1.88017 12.7445 1.6778C12.634 1.47544 12.4845 1.29692 12.3048 1.15251C12.1248 0.992241 11.9137 0.870863 11.6847 0.795975C11.4557 0.721088 11.2136 0.694307 10.9738 0.717308C10.7339 0.740309 10.5014 0.812593 10.2908 0.92964C10.0801 1.04669 9.89597 1.20597 9.74976 1.39751L1.29726 11.8975C1.07761 12.2214 0.972863 12.6096 0.999761 13Z' fill='#D9D9D9'/></svg></button>",
        nextArrow:"<button class='slick-next slick-arrow' aria-label='Previous' type='button'><svg width='14' height='26' viewBox='0 0 14 26' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.999761 13C0.998963 13.4089 1.14137 13.8052 1.40226 14.12L10.1523 24.62C10.4493 24.9774 10.8761 25.2021 11.3389 25.2448C11.8016 25.2875 12.2624 25.1445 12.6198 24.8475C12.9771 24.5505 13.2019 24.1236 13.2445 23.6609C13.2872 23.1981 13.1443 22.7374 12.8473 22.38L5.00726 13L12.5673 3.62C12.7126 3.441 12.8212 3.23503 12.8867 3.01394C12.9522 2.79285 12.9734 2.56099 12.949 2.33169C12.9246 2.10239 12.8551 1.88017 12.7445 1.6778C12.634 1.47544 12.4845 1.29692 12.3048 1.15251C12.1248 0.992241 11.9137 0.870863 11.6847 0.795975C11.4557 0.721088 11.2136 0.694307 10.9738 0.717308C10.7339 0.740309 10.5014 0.812593 10.2908 0.92964C10.0801 1.04669 9.89597 1.20597 9.74976 1.39751L1.29726 11.8975C1.07761 12.2214 0.972863 12.6096 0.999761 13Z' fill='#D9D9D9'/></svg></button>",
        responsive: [
            {
                breakpoint: 9999,  
                settings: "unslick"
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    infinite: true,
                    adaptiveHeight: true
                }
            }
        ]
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      super.hide();
      window.pauseAllMedia();
    }
    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }
  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-press-bar"] && !window.DesignMode) return;
  try {
    
    $('.icons-slider').slick({
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 9999,  
                settings: "unslick"
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    infinite: true,
                    adaptiveHeight: true
                }
            }
        ]
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
